import React from 'react';
import { Avatar, Box, Divider, IconButton, Menu, MenuItem, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from 'store/store';
import { logout } from 'store/actions/authActions';

interface IProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

/** Initials shown in the avatar, e.g. "robin.kueppers" -> "RK". */
const initialsOf = (username: string): string =>
  username
    .split(/[.\-_\s]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');

export const AccountMenu: React.FC<IProps> = ({ anchorEl, onClose }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.auth.user);

  const handleLogout = async () => {
    onClose();
    await dispatch(logout());
    navigate('/login');
  };

  const handleChangePassword = () => {
    onClose();
    navigate('/profile/change-password');
  };

  const handleChangeEmail = () => {
    onClose();
    navigate('/profile/change-email');
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            padding: '24px 32px 16px',
            borderRadius: '14px',
            width: '407px',
            maxWidth: 'calc(100vw - 32px)',
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
          <Avatar sx={{ width: 32, height: 32, backgroundColor: '#0247FF', fontSize: 13 }}>{initialsOf(user?.username ?? '')}</Avatar>
          <Typography sx={{ fontFamily: 'SparkasseWeb', fontWeight: 700, color: '#000000' }}>{user?.username}</Typography>
        </Stack>
        <IconButton onClick={onClose} size="large" aria-label="Menü schließen">
          <CloseIcon />
        </IconButton>
      </Box>

      <Typography sx={{ color: '#444444', paddingLeft: '44px', paddingBottom: '16px' }}>{user?.email}</Typography>

      <Divider />

      <MenuItem onClick={handleChangeEmail} sx={{ height: '52px', paddingLeft: 0, fontFamily: 'SparkasseWeb', color: '#000000' }}>
        E-Mail ändern
        <KeyboardArrowRight sx={{ ml: 'auto' }} />
      </MenuItem>

      <Divider />

      <MenuItem onClick={handleChangePassword} sx={{ height: '52px', paddingLeft: 0, fontFamily: 'SparkasseWeb', color: '#000000' }}>
        Passwort ändern
        <KeyboardArrowRight sx={{ ml: 'auto' }} />
      </MenuItem>

      <Divider />

      <MenuItem onClick={handleLogout} sx={{ height: '52px', paddingLeft: 0, fontWeight: 700, fontFamily: 'SparkasseWeb', color: '#000000' }}>
        Abmelden
        <KeyboardArrowRight sx={{ ml: 'auto' }} />
      </MenuItem>
    </Menu>
  );
};
